import React, { useState } from 'react';
import { Divider } from '@mui/material';
import { FieldSelect } from './FieldSelect';
import { useUser } from '../../../../hooks/useUser';
import { isInternal, isAM } from '../../../../utils';
import { FieldImageUpload } from '../../../../components/fields/ImageUpload/ImageUpload';
import { FieldSwitch } from '../../../../components/fields/FieldSwitch/FieldSwitch';
import FieldInput from './FieldInput';
import FormRow from './row';
import FieldCheckbox from './FieldCheckbox';
import { IconCloseEye, IconEye, IconLock } from '../../../../utils/icons';
import { statusList } from './constants';
import { CustomTextArea } from '../../../../components/fields/CustomTextArea/CustomTextArea';

interface Props {
  create?: boolean;
  handleImageChange: (val: any) => void;
}
export default function FormBasics({ create, handleImageChange }: Props) {
  const { role } = useUser();
  const [showPwd, setShowPwd] = useState(false);
  const imageUpload = (
    <FieldImageUpload
      label="Image Upload"
      name="avatar"
      onChange={handleImageChange}
    />
  );

  return (
    <>
      <FormRow count={3}>
        <FieldInput
          name="emailAddress"
          label="Email"
          placeholder="name@example.com"
          required
          readOnly={!isInternal(role)}
        />
        {isInternal(role) && (
          <>
            <FieldInput name="slug" />
            <FieldInput
              name="password"
              placeholder="*******"
              type={showPwd ? 'text' : 'password'}
              required={create}
              postIcon={showPwd ? <IconCloseEye /> : <IconEye />}
              onIconClick={() => setShowPwd(!showPwd)}
            />
          </>
        )}
      </FormRow>

      <Divider />

      <FormRow count={3}>
        <FieldInput name="firstName" label="First Name" />
        <FieldInput name="lastName" label="Last Name" />
        <FieldInput name="displayName" label="Display Name" />
      </FormRow>

      {isInternal(role) && (
        <FormRow count={2}>
          <FieldInput name="proScore" label="Pro Score" readOnly />
          <FieldInput name="tier" readOnly />
        </FormRow>
      )}

      {isInternal(role) ? (
        <FormRow count={2}>
          {imageUpload}
          <div>
            <span className="text-base text-left block mb-2" style={{ color: 'var(--text)' }}>
              Disable Notifications
            </span>
            <FieldSwitch
              name="notifications_disabled"
              label="Disable all notifications for this expert (in-platform and email)"
            />
          </div>
        </FormRow>
      ) : (
        imageUpload
      )}
      {isInternal(role) && (
        <FieldCheckbox name="isProfileCompleted" text="Web profile complete" />
      )}

      <Divider />

      <FormRow>
        <CustomTextArea name="description" label="Bio" rows={5}/>
      </FormRow>

      {isInternal(role) && (
        <>
          <FormRow>
            <FieldInput
              name="short_description"
              label="Short Bio"
              subLabel="250 characters"
            />
          </FormRow>

          <FormRow count={2}>
            <FieldSelect name="status" required options={statusList} />
            {isAM(role) && (
              <FieldInput
                name="featured"
                label="Featured Expert ID"
                type="number"
                placeholder="Enter featured expert ID"
              />
            )}
          </FormRow>

          <FormRow count={2}>
            <FieldInput name="notes" multiline />
            <FieldInput name="persona" multiline />
          </FormRow>
        </>
      )}

      <Divider />

      <FormRow>
        <FieldInput
          name="tdcLink"
          label="TDC link"
          placeholder="https://"
          readOnly
          postIcon={<IconLock />}
        />
      </FormRow>

      {isInternal(role) && (
        <FormRow count={2}>
          <FieldInput
            name="userid"
            label="User ID"
            readOnly
            postIcon={<IconLock />}
          />
          <FieldInput
            name="dateCreated"
            label="Date Created"
            readOnly
            postIcon={<IconLock />}
          />
        </FormRow>
      )}
    </>
  );
}
